import { FileImageOutlined, HeartFilled, HeartOutlined } from "@ant-design/icons";
import { Button, Col, Row, Space, Statistic } from "antd";
import { format } from "date-fns";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCareProductMutation, useUncareProductMutation } from "../../../redux/api/ProductApi";
import { useAppDispatch, useAppSelector } from "../../../redux/Hooks";
import { AuctionResponse } from "../../auction/types";
import { toggleLoginModal } from "../../login/redux/LoginSlice";

type CardProps = {
    price?: number,
    description?: string,
    item: AuctionResponse,
    reloadPage: () => void,
}

const ItemListCardOther = ({ price, description, item, reloadPage }: CardProps) => {
    const [isFavoriteHovering, setIsFavoriteHovering] = useState(false);
    const navigate = useNavigate();

    const userState = useAppSelector(state => state.login);
    const dispatch = useAppDispatch();

    const [uncareProduct] = useUncareProductMutation();
    const [careProduct] = useCareProductMutation();

    const onFavoriteMouseOver = () => {
        setIsFavoriteHovering(true);
    }

    const onFavoriteMouseOut = () => {
        setIsFavoriteHovering(false);
    }

    const onFavoriteClick = () => {
        if (!userState.user.userId) {
            dispatch(toggleLoginModal())
        } else if (item.isCare) {
            // uncare
            uncareProduct({ productId: item.productId, statuteId: item.statute.statuteId }).unwrap().then(() => {
                reloadPage();
            })
        } else {
            // care
            careProduct({ productId: item.productId, statuteId: item.statute.statuteId }).unwrap().then(() => {
                reloadPage();
            })
        }
    }

    const cardImageElement = useMemo(() => {
        let cardUrl = process.env.REACT_APP_API_URL + `/files/downloadFile/`;

        if (item.vbAttachmentImages && item.vbAttachmentImages?.length) {
            let avatarIndex = item.vbAttachmentImages.findIndex(img => img.storageType === "avatar");
            cardUrl += avatarIndex !== -1 ? `${item.vbAttachmentImages[avatarIndex].attachmentId}` : `${item.vbAttachmentImages[0].attachmentId}`;
        } else {
            cardUrl = "";
        }

        if (cardUrl) {
            return (
                <img
                    style={{ objectFit: 'cover', display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
                    width='100%'
                    height='200px'
                    alt="example"
                    src={cardUrl}
                    className="item-card-cover" />
            )
        }

        return (
            <div style={{ width: '100%', height: 200, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <FileImageOutlined style={{ fontSize: 50 }} />
            </div>
        )
    }, [item.vbAttachmentImages])

    return (
        <Row className="item-list-card" gutter={30} onClick={() => navigate(`/auction-item-other/${item.productId}/${item.statute.statuteId}`)}>
            <Col span={5} style={{ marginLeft: -15 }}>
                {/* <img
                    alt="example"
                    src={ItemImage}
                    className="item-card-cover"
                    style={{ borderRadius: '15px 0px 0px 15px', width: '100%', height: 200, objectFit: 'cover' }} /> */}
                {cardImageElement}
            </Col>
            <Col span={19}>
                <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center', background: "#F1F1F1", padding: '6px 20px' }}>
                        <span className="font-size-12">Giá khởi điểm </span>
                        <span className="font-size-18 font-bold" style={{ marginLeft: 10 }}>
                            <Statistic
                                value={item.startPrice}
                                groupSeparator="."
                                decimalSeparator=","
                                precision={0}
                                style={{ display: 'inline-block' }}
                                valueStyle={{ fontSize: 18, fontFamily: 'Quicksand' }} /> VNĐ
                        </span>
                    </div>
                    <div className="item-card-action-list">
                        <div
                            style={{ alignSelf: 'center', marginLeft: 20 }}
                            onMouseEnter={onFavoriteMouseOver}
                            onMouseLeave={onFavoriteMouseOut}
                            onClick={(e) => {
                                e.stopPropagation();
                                onFavoriteClick();
                            }}>
                            {isFavoriteHovering || item.isCare ?
                                <HeartFilled style={{ color: '#E59F17', fontSize: 25 }} /> :
                                <HeartOutlined style={{ color: 'black', fontSize: 25 }} />
                            }

                        </div>
                    </div>
                </div>
                <div className="font-size-18" style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {item.productName.trim() || "-"}
                </div>
                <div style={{ marginTop: 40, display: 'flex', justifyContent: "space-between", alignItems: 'center', width: '100%' }}>
                    <div>
                        <span className="font-size-12">Thời gian đấu giá: </span>
                        <span className="font-size-12">{item.statute.startDate ? format(new Date(item.statute.startDate), "HH:mm dd/MM/yyyy") :
                            format(new Date(), "HH:mm dd/MM/yyyy")}</span>
                    </div>
                </div>
            </Col>
        </Row>
    )
}

export default ItemListCardOther;